import React from 'react';
import styles from './about-author.module.css';
export default function AboutAuthor() {
  const logos = [
    { src: "maria-shriver-logo.webp", alt: "Maria Shriver" },
    { src: "wh-logo.webp", alt: "Women's Health" },
    { src: "oprah-logo.webp", alt: "Oprah" },
    { src: "npr-logo.svg", alt: "NPR" },
    { src: "mh-logo.webp", alt: "Marie Claire" },
    { src: "yj-logo.webp", alt: "Yoga Journal" },
    { src: "health-logo.webp", alt: "Health Magazine" },
    { src: "prevention-logo.webp", alt: "Prevention" },
    { src: "webmd-transparent.png", alt: "WebMD" },
    { src: "good-housekeeping-logo.webp", alt: "Good Housekeeping" },
    { src: "jandj-logo.webp", alt: "Johnson & Johnson" },
    { src: "levels-logo.png", alt: "Levels" },
    { src: "peloton-logo.webp", alt: "Peloton" },
    // { src: "acorns.png", alt: "Acorns" },
    // { src: "xanterra.png", alt: "Xanterra" },
  ];

  return (
    <section id="about-author" className={styles.aboutAuthor}>
      <div className={styles.container}>
        <div className={styles.authorContent}>
          <div className={styles.authorImage}>
            <img src="assets/images/mr-headshot2.jpeg" alt="Meghan Rabbitt" className={styles.authorHeadshot} />
          </div>
          <div className={styles.authorText}>
            <h2 className="section-header">Meet the Author</h2>
            <p>Meghan Rabbitt is an award-winning journalist who specializes in writing about women&rsquo;s health and wellness. Her work has appeared in many national publications, including Women&rsquo;s Health, Oprah Daily, Prevention, Maria Shriver&rsquo;s Sunday Paper, and more. She&rsquo;s known for translating complex medical and scientific topics into clear, actionable information—and for telling stories that help readers better understand their bodies, their health, and themselves.</p>
          </div>
        </div>

        <div id="work" className={styles.otherWorkFull}>
          <h3 className="section-header center medium">You&rsquo;ll find Meghan&rsquo;s work in...</h3>
          <div className={styles.brandLogosElegant}>
            <div className={styles.logoSection}>
              <div className={styles.logoGridElegant}>
                {logos.map((logo, index) => (
                  <div key={index} className={styles.logoItem}>
                    <img
                      src={`assets/logos/${logo.src}`}
                      alt={logo.alt}
                      className={styles.brandLogo}
                    />
                  </div>
                ))}


                <div className={styles.seeMoreWorkLink}>
                  <a
                    href="https://work.meghanrabbitt.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    See more
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}